import React from 'react';
import styles from './fallbackLayout.module.scss';
import {Loader} from 'app/views/components/loader';

export const FallbackLayout = () => (
    <div className={styles.fallbackLayout}>
        <Loader />
    </div>
);
